import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackService } from 'app/app-wrapper/snack.service';
import { ApiService } from 'app/core/api/api.service';
import { DialogService } from 'primeng/dynamicdialog';
import { TermsOfConditionComponent } from '../terms-of-condition/terms-of-condition.component';
import { passwordMatchValidator } from './password-repeat.validator';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';
import { map } from 'leaflet';
import { catchError, tap } from 'rxjs';
import { AuthService } from '../../auth.service';

import { ToastModule } from 'primeng/toast';
import { CardModule } from 'primeng/card';
import { FloatLabel, FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';

@Component({
    selector: 'verify-user',
    templateUrl: './verify-user.component.html',
    imports: [
    ReactiveFormsModule,
    ToastModule,
    CardModule,
    FloatLabelModule,
    InputTextModule,
    TranslateModule,
    ButtonModule,
    CheckboxModule
]
})

export class VerifyUserComponent implements OnInit {
    verificationForm: FormGroup;
    token: string;

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private api: ApiService,
        private snack: SnackService,
        private dialogService: DialogService,
        private authService: AuthService,
    ) { }

    ngOnInit(): void {
        this.token = this.route.snapshot.paramMap.get('token');
        this.verificationForm = this.fb.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            phoneNumber: ['', Validators.required],
            password: ['', [Validators.required, Validators.minLength(6)]],
            passwordrepeat: ['', [Validators.required, Validators.minLength(6)]],
            privacyPolicyAccepted: [false, Validators.requiredTrue],
            termsOfConditionsAccepted: [false, Validators.requiredTrue],
        },{ validators: passwordMatchValidator() });
    }

    async onSubmit(): Promise<void> {
        if (this.verificationForm.valid) {
            delete this.verificationForm.value.passwordrepeat;
            
            const userData = {
                ...this.verificationForm.value,
                verified: true,
            }

            this.authService.verifyUser(this.token, this.verificationForm.value )

            

            // this.api.verifyUser(this.token, userData).pipe(
            //     tap((x) => {
            //         this.snack.success('Account verified successfully. Please login to continue.');
            //         this.router.navigate(['app/login']);

            //     }),
            //     catchError((error) => {
            //         console.error(error);
            //         this.snack.error(error.error.message);
            //         throw error;
            //     })
            // ).subscribe();
        }
    }

    showPrivacyDialog(): void {
        setTimeout(() => {
            this.dialogService.open(PrivacyPolicyComponent, {
                closable: true,
                appendTo: 'body',
            })
        }, 1)
   
    }

    showTermsDialog(): void {
        setTimeout(() => {
            this.dialogService.open(TermsOfConditionComponent, {
                closable: true,
                appendTo: 'body',
            })
        }, 1)

    }

    get passwordMismatchError(): boolean {
        return this.verificationForm.hasError('passwordMismatch');
      }
}
